import { CreateTenantRate } from "@models";
import requests from "./agent";

export const rateService = {
  createTenantRate: async (request: CreateTenantRate) => {
    await requests.post<any>("/api/TenantRate/Create", request);
  },
};
